<template>
    <div class="win">
        <div class="header">
            <div class="navItem">
                <i class="iconfont el-icon-setting"></i>
                <div class="title" v-bind:style="{ letterSpacing: language === 'en' ? '0px':''}">设备管理</div>
            </div>
        </div>
        <div class="content" v-loading="loading" element-loading-text="Loading" element-loading-spinner="el-icon-loading" element-loading-background="rgba(42, 43, 44, 0.6)">
            <el-form @submit.native.prevent class="table_header tableSearchForm" :inline="true" size="small" label-position="left">
                <div class="btn btn_active" style="margin-right: 10px" @click="add"><span>{{ $t('ems.add') }}</span></div>
                <div class="btn btn_active" style="margin-right: 10px" @click="deleteAll"><span>{{ $t('ems.alarm.delete') }}</span></div>
                <el-form-item label="网关选择">
                    <el-select v-model="form.gatewayNos" multiple  collapse-tags placeholder="请选择" style="width: 220px" popper-class="selectDown" clearable>
                        <el-option v-for="item in gatewayOption" :key="item.value"  :value="item.gatewayNo" :label="item.gatewayNo">
                            <div style="float: left">{{ item.gatewayNo }}</div>
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="设备类型">
                    <el-select v-model="form.deviceTypes" placeholder="请选择" style="width: 200px" popper-class="selectDown" multiple  collapse-tags clearable>
                        <el-option v-for="item in deviceOption" :key="item.type" :label="item.name" :value="item.type"></el-option>
                    </el-select>
                </el-form-item>
                <div class="btn btn_active" @click="search"><i class="iconfont icon-sousuo"></i><span>{{ $t('ems.history.search') }}</span></div>


                <div class="btn btn_active"  style="float:  right; width: 100px">
                    <el-button type="text" icon="el-icon-download" @click="downLoad" style="width: 100%; height: 100%;line-height: 30px; border-radius: 0px; color: rgb(10, 207, 230); font-size: 16px; padding: 0 10px">{{ $t('index.export') }}</el-button>
                </div>
                <div class="btn btn_active"  style="float:  right; width: 100px">
                    <el-button type="text" icon="el-icon-upload" @click="handleUpload" style="width: 100%; height: 100%;line-height: 30px; border-radius: 0px; color: rgb(10, 207, 230); font-size: 16px; padding: 0 10px">{{ $t('index.upload') }}</el-button>
                </div>
                <div class="btn btn_active"  style="float:  right; width: 160px">
                    <el-button type="text" icon="el-icon-paperclip" @click="handleBind" style="width: 100%; height: 100%;line-height: 30px; border-radius: 0px; color: rgb(10, 207, 230); font-size: 16px; padding: 0 10px">网关设备舱绑定</el-button>
                </div>

                <div class="btn btn_active" style="float:  right; width: 140px">
<!--                    <el-select  placeholder="请选择操作类型" style="width: 220px;" popper-class="selectDown"  @change="handleSend">-->
<!--                        <el-option label="批量更新上级设备" :value="0"></el-option>-->
<!--                        <el-option label="批量更新所属子系统" :value="1"></el-option>-->
<!--                        <el-option label="批量更新扩展字段" :value="2"></el-option>-->
<!--                        <el-option label="批量更新绑定标签" :value="3"></el-option>-->
<!--                        <el-option label="批量更新堆参数" :value="4"></el-option>-->
<!--                    </el-select>-->

                    <el-dropdown @command="handleCommand" trigger="click">
                        <span class="el-dropdown-link" style="color: #0acfe6">批量更新参数<i class="el-icon-arrow-down el-icon--right"></i></span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="0">1.批量更新上级设备</el-dropdown-item>
                            <el-dropdown-item command="1">2.批量更新所属子系统</el-dropdown-item>
                            <el-dropdown-item command="2">3.批量更新扩展字段</el-dropdown-item>
                            <el-dropdown-item command="3">4.批量更新绑定分组</el-dropdown-item>
                            <el-dropdown-item command="4">5.批量更新堆参数</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </el-form>
            <el-table
                    :data="list"
                    style="width: 100%"
                    v-loading="listLoading"
                    border
                    size="small"
                    :height="730"
                    class="BMSTable"
                    @selection-change="handleSelectionChange">

            >
                <el-table-column type="selection" width="55" align="center"></el-table-column>
                <el-table-column  label="设备编号" prop="deviceNo" width="200"></el-table-column>
                <el-table-column  label="设备别名" prop="deviceAlias" width="150"></el-table-column>
                <el-table-column  label="设备名称" prop="deviceName" width="200"></el-table-column>
                <el-table-column  label="设备类型" prop="deviceTypeName" width="120"></el-table-column>
                <el-table-column  label="网关编号" prop="gatewayNo" width="150"></el-table-column>
                <el-table-column  label="所属上级设备" prop="upDeviceDeviceName" width="150"></el-table-column>
                <el-table-column  label="所属子系统" prop="systemName" width="120"></el-table-column>
                <el-table-column  label="绑定标签" prop="bindTag"></el-table-column>
<!--                <el-table-column  label="扩展字段" prop="exdInfo"></el-table-column>-->
                <el-table-column  :label="$t('ems.operate')" align="center" width="240">
                    <template slot-scope="scope">
                        <el-button @click.native.prevent="handleEdit(scope.row)" type="text" size="small" icon="el-icon-edit-outline">{{ $t('ems.edit') }}</el-button>
                        <el-button @click.native.prevent="handleDelete(scope.row.id)" type="text" size="small" icon="el-icon-delete">{{ $t('ems.alarm.delete') }}</el-button>
                        <el-button @click.native.prevent="onShowDataCheck(scope.row)" type="text" size="small" icon="el-icon-tickets">数据检测</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="bindGatewayVis">
            <el-dialog title="网关绑定" :visible.sync="bindGatewayVis" append-to-body width="600px" top="200px" :close-on-click-modal="false" custom-class="dialog-custom-class">
                <el-form @submit.native.prevent class="table_header tableSearchForm" style="width: 100%; margin-left: 60px" size="small"  label-position="left" label-width="120px">
                    <template v-for="(item, index) in gatewayOption">
                        <div class="gatewayBind" :key="index">
                            <div> 网关编号: {{ item.gatewayNo }}</div>
                            <el-select v-model="gatewayBindForm[item.gatewayNo]" placeholder="请选择"  popper-class="selectDown" size="mini">
                                <el-option value="" label="无"></el-option>
                                <el-option v-for="item in containerList" :key="item.id" :label="item.containerName" :value="item.id"></el-option>
                            </el-select>
                        </div>
                    </template>
                    <span style="margin-left: 127px">未对一个设备舱绑定多个不同网关的情况做强校验</span>
                </el-form>

                <div slot="footer" class="dialog-footer">
                    <el-button size="small" @click="bindGatewayVis = false">{{ $t('ems.strategy.cancel') }}</el-button>
                    <el-button size="small" type="primary" @click="subminBind">{{ $t('ems.strategy.confirm') }}</el-button>
                </div>
            </el-dialog>
        </div>
        <div v-if="addVisible">
            <el-dialog :title="addForm.id ? '设备编辑' : '设备新增'" :visible.sync="addVisible" append-to-body width="600px"
                       top="70px" :close-on-click-modal="false" custom-class="dialog-custom-class">
                <el-form @submit.native.prevent class="table_header tableSearchForm" style="width: 100%; margin-left: 60px" size="small" label-width="120px" label-position="left" :model="addForm" :rules="rules" ref="ruleForm">
                    <el-form-item label="设备编号" prop="deviceNo"><el-input v-model="addForm.deviceNo" :placeholder="$t('ems.alarm.PleaseEnterContent')" style="width: 300px"></el-input></el-form-item>
                    <el-form-item label="设备别名" prop="deviceAlias"><el-input v-model="addForm.deviceAlias" :placeholder="$t('ems.alarm.PleaseEnterContent')" style="width: 300px"></el-input></el-form-item>
                    <el-form-item label="设备名称" prop="deviceName"><el-input v-model="addForm.deviceName" :placeholder="$t('ems.alarm.PleaseEnterContent')" style="width: 300px"></el-input></el-form-item>
                    <el-form-item label="网关编号" prop="gatewayNo"><el-input v-model="addForm.gatewayNo" :placeholder="$t('ems.alarm.PleaseEnterContent')" style="width: 300px"></el-input></el-form-item>

                    <el-form-item label="设备类型" prop="deviceType">
                        <el-select v-model="addForm.deviceType" placeholder="请选择" style="width: 300px" popper-class="selectDown" @change="deviceTypeChange">
                            <el-option v-for="item in deviceOption" :key="item.value" :label="item.name" :value="item.type"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="上级设备" prop="upDeviceId" v-if="addForm.deviceType === 'DCB' || addForm.deviceType === 'CU'">
                        <el-select v-model="addForm.upDeviceId" placeholder="请选择" style="width: 300px" popper-class="selectDown">
                            <el-option v-for="item in upDeviceList" :key="item.id" :label="item.deviceName" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="所属子系统">
                        <el-select v-model="addForm.systemId" placeholder="请选择" style="width: 300px" popper-class="selectDown">
                            <el-option v-for="item in systemList" :key="item.id" :label="item.systemName" :value="+item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="所属设备舱">
                        <el-select v-model="addForm.containerId" placeholder="请选择" style="width: 300px" popper-class="selectDown" clearable>
                            <el-option v-for="item in containerList" :key="item.id" :label="item.containerName" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="绑定标签"><el-input v-model="addForm.bindTag" :placeholder="$t('ems.alarm.PleaseEnterContent')" style="width: 300px" disabled></el-input></el-form-item>
                    <el-form-item label="扩展字段">
                        <el-input type="textarea" :rows="3" placeholder="请输入内容" v-model="addForm.exdInfo"  style="width: 300px"></el-input>
                    </el-form-item>
                    <el-form-item label="备注">
                        <el-input type="textarea" :rows="3" placeholder="请输入内容" v-model="addForm.remark"  style="width: 300px"></el-input>
                    </el-form-item>
                    <span>请留意,未对数据做强校验</span>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button size="small" @click="addVisible = false">{{ $t('ems.strategy.cancel') }}</el-button>
                    <el-button size="small" type="primary" @click="subminAdd">{{ $t('ems.strategy.confirm') }}</el-button>
                </div>
            </el-dialog>
        </div>
        <div v-if="commandVis">
            <el-dialog title="批量更新" :visible.sync="commandVis" append-to-body :width="commandAction == 3 ? '1200px' : '600px'" :top="commandAction == 3 ? '50px' : '200px'" :close-on-click-modal="false" custom-class="dialog-custom-class">
                <el-form @submit.native.prevent class="table_header tableSearchForm" style="width: 100%; margin-left: 60px" size="small"  label-position="left" label-width="120px">

                    <template v-if="commandAction == 0">
                        <el-form-item label="上级设备">
                            <el-select v-model="commandForm.deviceType" placeholder="请选择" style="width: 220px" popper-class="selectDown">
                                <el-option v-for="item in getDeviceList(multipleSelection[0].deviceType == 'DCB' ? 'CU' : 'DUI')" :key="item.id" :label="item.deviceName" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <span>说明：只需要配置电池包和簇的上级设备; <br> 电池包的上级设备是簇， 簇的上级设备是堆，<br> 新版本不用配置电池包，老版本需要配置</span>

                    </template>
                    <template v-else-if="commandAction == 1">
                        <el-form-item label="所属子系统">
                            <el-select v-model="commandForm.systemId" placeholder="请选择" style="width: 220px" popper-class="selectDown">
                                <el-option v-for="item in systemList" :key="item.id" :label="item.systemName" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </template>
                    <template v-else-if="commandAction == 2">
                        <el-form-item label="扩展字段">
                            <el-input type="textarea" :rows="3" placeholder="请输入内容" v-model="commandForm.exdInfo"  style="width: 300px"></el-input>
                        </el-form-item>
                    </template>
                    <template v-else-if="commandAction == 3">
                        <DeviceDrag :list="deviceList" @close="closePanel"></DeviceDrag>
                    </template>
                    <template v-else-if="commandAction == 4">
                        <el-form-item label="每堆的设计容量" required>
                            <el-input v-model="commandForm.duiPlanCapacity" oninput="value=value.replace(/[^\-?\d.]/g,'')" style="width: 300px"></el-input>
                        </el-form-item>
                        <el-form-item label="每堆下挂的电池包数量">
                            <el-input v-model="commandForm.duiDcPackNum" oninput="value=value.replace(/[^\-?\d.]/g,'')" style="width: 300px"></el-input>
                        </el-form-item>
                        <el-form-item label="每堆下挂的总电芯数量">
                            <el-input v-model="commandForm.duiDcNum" oninput="value=value.replace(/[^\-?\d.]/g,'')" style="width: 300px"></el-input>
                        </el-form-item>
                        <el-form-item label="每堆下挂的总温度点数量">
                            <el-input v-model="commandForm.duiTempNum" oninput="value=value.replace(/[^\-?\d.]/g,'')" style="width: 300px"></el-input>
                        </el-form-item>
                    </template>
                </el-form>

                <div slot="footer" class="dialog-footer" v-if="commandAction !== 3">
                    <el-button size="small" @click="commandVis = false">{{ $t('ems.strategy.cancel') }}</el-button>
                    <el-button size="small" type="primary" @click="subminBacth">{{ $t('ems.strategy.confirm') }}</el-button>
                </div>
            </el-dialog>
        </div>
        <div v-if="uploadVis">
            <el-dialog :title="$t('index.upload')" :visible.sync="uploadVis" append-to-body width="800px" top="100px" :close-on-click-modal="false" custom-class="dialog-custom-class">
                <el-form @submit.native.prevent class="table_header tableSearchForm"  size="small" label-width="180px" label-position="left" v-loading="uploadLoading">
                    <el-form-item :label="$t('systemSetting.TemplateDownload')" style="font-size: 14px">
                        <el-button type="primary" @click="handleTemplate"
                        >{{$t('systemSetting.clickDownLoad')}}<i class="el-icon-download el-icon--right"></i
                        ></el-button>
                    </el-form-item>
                    <el-form-item label="设备舱">
                        <el-select v-model="containerId" placeholder="请选择" style="width: 300px" popper-class="selectDown">
                            <el-option v-for="item in containerList" :key="item.id" :label="item.containerName" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('index.upload')" style="margin-right: 100px">
                        <el-upload
                                ref="upload"
                                class="avatar-uploader-login"
                                action="/api/blade-wems/deviceManagement/device/import"
                                :multiple="false"
                                :show-file-list="true"
                                :headers="headers"
                                :auto-upload="false"
                                :limit="1"
                                :on-exceed="handleExceed"
                                :on-success="uploadSuccess"
                                :on-change="handleChange"
                                :on-error="handleError"
                                :data="{containerId: containerId}"
                                :before-upload="beforeAvatarUpload">
                            <i class="el-icon-upload avatar-uploader-icon"></i>
                            <div class="el-upload__tip" slot="tip"></div>
                        </el-upload>
                    </el-form-item>
                    <span style="margin-left: 148px"> 导入文件一般都是从iot平台的“设备管理->设备->导出”页面中导出的。</span>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button size="small" @click="uploadVis = false">{{ $t('ems.strategy.cancel') }}</el-button>
                    <el-button size="small" type="primary" @click="submitUpload">{{ $t('ems.strategy.confirm') }}</el-button>
                </div>
            </el-dialog>
        </div>
        <div v-if="dataCheckVisible">
            <el-dialog title="数据检测" :visible.sync="dataCheckVisible" append-to-body width="1200px" top="100px" :close-on-click-modal="false" custom-class="dialog-custom-class">
                <el-form class="table_header tableSearchForm" style="width: 100%;" size="small"  label-position="left" label-width="100px">
                    <el-form-item label="自检结果">
                        <el-select @change="onDataCheckChange" v-model="dataCheckForm.errorCode" clearable placeholder="请选择" style="width: 300px" popper-class="selectDown">
                            <el-option label="参数表tag和服务都匹配" value="0"></el-option>
                            <el-option label="参数表没有对应的tag和服务，但有数据上报" value="3"></el-option>
                            <el-option label="参数表对应tag和服务没有匹配" value="2"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <el-table
                    :data="dataCheckList"
                    v-loading="dataCheckLoading"
                    style="width: 100%"
                    border
                    size="small"
                    :height="600"
                    class="BMSTable">
                <el-table-column  label="设备编码" prop="deviceNo" width="200"></el-table-column>
                <el-table-column  label="TAG编码" prop="tagNo" width="80"></el-table-column>
                <el-table-column  label="服务identifier" prop="identifier" width="160"></el-table-column>
                <el-table-column  label="描述" prop="tagDesc" width="100"></el-table-column>
                <el-table-column  label="数据值" prop="data" width="80"></el-table-column>
                <el-table-column  label="采集时间" prop="collectTime" width="160"></el-table-column>
                <el-table-column  label="自检结果" prop="errorInfo"></el-table-column>
                <el-table-column  label="自检结果代码" prop="errorCode" width="100"></el-table-column>
            </el-table>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    import { exportDevices, getDeviceManagementList, getGatewayAndContainerList, getDeviceType, getContainerList, updateBind, getSubSystem, saveOrUpdataDevice, deleteDevice, updataUpDevice, updateDeviceSys, updateDeviceExdInfo, checkDevicerigth, updateDeviceDui, deviceDataCheck, deleteDevicePacth}from "@/api/spms";
    import { isJSON } from "@/utils/util";
    import i18n from "@/lang";
    import spmsweb from '@/config/spmsweb';
    import { getStore } from "@/utils/store";
    import { Base64 } from 'js-base64/base64';
    import DeviceDrag from "./components/deviceDrag";
    import { exportFile } from "@/utils/util";

    export default {
        name: "mainSys",
        components: {DeviceDrag},
        data(){
            return{
                opacity: 0,
                loading: false,
                form: {
                    gatewayNos: [],
                    deviceTypes: [],
                },
                listLoading: false,
                size: 20,
                page: 1,
                list: [],
                total: 0,
                addVisible: false,
                addForm: {

                },
                roleList: [],
                rules: {
                    deviceNo: { required: true, message: "请填写内容", trigger: 'blur' },
                    deviceAlias: { required: true,  message: "请填写内容", trigger: 'blur' },
                    deviceName: { required: true, message: "请填写内容", trigger: 'blur' },
                    gatewayNo: { required: true, message: "请填写内容", trigger: 'blur' },
                    deviceType: { required: true,  message: "请选择", trigger: 'change' },
                },

                gatewayOption: [],
                deviceOption: [],
                multipleSelection: [],

                containerList: [],

                bindGatewayVis:  false,
                gatewayBindForm: {},
                systemList: [],

                deviceList: [],

                commandVis: false,

                commandAction: 0,
                commandForm: {

                },

                uploadVis: false,
                headers: {},
                fileList: [],
                uploadLoading: false,
                accept:"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel",
                containerId: '',

                dataCheckVisible: false,
                dataCheckList: [],
                dataCheckLoading: false,
                dataCheckForm: {
                    errorCode: null
                }
            }
        },
        computed: {
            ...mapGetters(["language"]),
            upDeviceList(){
                if(this.addForm.deviceType){
                    if(this.addForm.deviceType == 'DCB'){
                      return this.deviceList.filter(i => i.deviceType === 'CU' );
                    }
                    if(this.addForm.deviceType == 'CU'){
                        return this.deviceList.filter(i => i.deviceType === 'DUI' );
                    }
                    return [];
                }
                return [];
            }
        },
        filters: {
            nullFormat(val){
                if(val === null || val === undefined){
                    return "--"
                }else {
                    return val
                }
            },

        },
        created(){
            this.headers = {
                Authorization: `Basic ${Base64.encode(
                    `${spmsweb.clientId}:${spmsweb.clientSecret}`
                )}`,
                "Blade-Auth": "bearer " + getStore({ name: "access_token" }),
                // 'Content-Type': 'application/json'
            };
        },
        mounted(){
            setTimeout(() => {
                this.opacity = 1;
            },200);
            this.initOption();
            this.loadData(true);
        },
        methods: {
            initOption(){
                this.getBind();
                getDeviceType().then(res => {
                    if(res && res.data && res.data.data){
                        this.deviceOption = res.data.data;
                    }
                })

                getContainerList().then(res => {
                    if(res && res.data && res.data.data){
                        this.containerList = res.data.data.records || [];
                    }
                })

                getSubSystem().then(res => {
                    if(res && res.data && res.data.data){
                        this.systemList = res.data.data.records;
                    }
                })
            },

            getBind(){
                getGatewayAndContainerList().then(res => {
                    if(res && res.data && res.data.data){
                        this.gatewayOption = res.data.data;
                        const gatewayBindForm = {};
                        this.gatewayOption.forEach(item => {
                            if(item.containerId !== null){
                                gatewayBindForm[item.gatewayNo] = item.containerId  + '';
                            }else{
                                gatewayBindForm[item.gatewayNo] = "";
                            }
                        })
                        this.gatewayBindForm = gatewayBindForm;
                        console.log( this.gatewayBindForm )
                    }
                })
            },

            search(){
                this.page = 1;
                this.loadData();
            },
            loadData(first = false){
                this.listLoading = true;
                const params = {... this.form};
                params.current = this.page;
                params.size = this.size;
                params.gatewayNos =  params.gatewayNos.join(',');
                params.deviceTypes =  params.deviceTypes.join(',');
                getDeviceManagementList(params).then(res => {
                    this.listLoading = false;
                    this.list = res.data.data;
                    // this.total = res.data.data.total;
                    if(first){
                        this.deviceList = res.data.data;
                    }
                }).catch(err => {
                    this.listLoading = false;
                    console.log(err)
                });
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            handleSizeChange(val) {
                this.page = 1;
                this.size = val;
                this.loadData();
            },
            handleCurrentChange(val) {
                this.page = val;
                this.loadData();
            },
            reset(){
                this.page= 1;
                this.form = {
                    account: '',
                    realName: '',
                };
                this.loadData();
            },
            add(){
                this.addForm = {

                };
               this.addVisible= true;
            },
            handleEdit(row){
                this.addVisible= true;
                this.addForm = JSON.parse(JSON.stringify(row));
                this.addForm.containerId = this.addForm.containerId === null ?  '' : (this.addForm.containerId + '');
                this.addForm.exdInfo = JSON.stringify( this.addForm.exdInfo );
            },

            subminAdd(){
                this.$refs["ruleForm"].validate((valid) => {
                    if (valid) {
                        const params = {...this.addForm};
                        if(params.exdInfo == undefined || params.exdInfo == ""){
                            params.exdInfo = {}
                        }else{
                            if(isJSON(params.exdInfo) == false){
                                this.$message.success("扩展字段必须为合法的JSON！");
                                return false
                            }else{
                                params.exdInfo = JSON.parse(params.exdInfo);
                            }
                        }
                        saveOrUpdataDevice(params).then(() => {
                            this.$message.success(i18n.t("ems.strategy.AddedSuccessfully")); 
                            this.loadData();
                            this.addVisible = false;
                        }).catch(err => {
                            console.log(err);
                            this.$message.error(i18n.t("ems.addFailedTip") + err) 
                        });
                    } else {
                        return false;
                    }
                });

            },

            handleDelete(id){
                this.$confirm(i18n.t("ems.alarm.sureyouwanttodothis"), {
                    confirmButtonText: i18n.t("ems.strategy.confirm"),
                    cancelButtonText:  i18n.t("ems.strategy.cancel"),
                    type: "warning"
                }).then(() => {
                    deleteDevice(id).then(() =>  {
                        this.$message.success(i18n.t("ems.strategy.DeletedSuccessfully"));
                        this.loadData();
                    }).catch(err => {
                        this.$message.error(err)
                    });
                }).then(() => {
                });
            },


            handleBind(){
                this.bindGatewayVis = true;
                this.getBind();
            },

            subminBind(){
                const params = [];
                let flag = true;
                for(let item in this.gatewayBindForm){
                    if( this.gatewayBindForm[item] == undefined || this.gatewayBindForm[item] == null){
                        flag = false;
                    }else{
                        const temp = {
                            "gatewayNo": item,
                            "containerId": this.gatewayBindForm[item],
                        };
                        temp.containerName = (this.containerList.find(i => i.id == temp.containerId) || {}).containerName;
                        params.push(temp);
                    }
                }

                if(flag == false){
                    this.$message.error("请绑定设备舱!")
                    return false;
                }

                updateBind(params).then(res => {
                    if(res && res.data && res.data.success){
                        this.$message.success("操作成功!");
                        this.loadData();
                        this.bindGatewayVis = false;
                    }else{
                        this.$message.error("操作失败!");
                    }
                }).catch(err => {
                    console.log(err);
                    this.$message.error("操作失败!");
                })
            },

            handleCommand(val){
                val =+val;
                this.commandAction = val;
                this.commandForm = {};

                if(val === 0){
                    if(this.multipleSelection.length === 0){
                        this.$message.warning("请选择电池包或者簇设备！")
                        return false;
                    }

                    let isDCB = true;
                    for(let i of this.multipleSelection){
                        if(i.deviceType !== 'DCB'){
                            isDCB = false;
                        }
                    }

                    let isCU = true;
                    for(let i of this.multipleSelection){
                        if(i.deviceType !== 'CU'){
                            isCU = false;
                        }
                    }

                    if(isDCB === false && isCU === false){
                        this.$message.warning("请选择电池包或者簇设备！")
                        return false;
                    }

                    this.commandVis = true;
                }else if(val == 1){
                    if(this.multipleSelection.length === 0){
                        this.$message.warning("请选择电池包或者簇设备！")
                        return false;
                    }
                    this.commandVis = true;
                }else if(val == 2){
                    if(this.multipleSelection.length === 0){
                        this.$message.warning("请选择电池包或者簇设备！")
                        return false;
                    }
                    let flag = true;
                    let tempDeviceType = this.multipleSelection[0].deviceType;
                    for(let i of this.multipleSelection){
                        if(i.deviceType !== tempDeviceType){
                            flag = false;
                        }
                    }
                    if(flag === false){
                        this.$message.warning("请选择相同的设备类型！");
                        return false;
                    }

                    this.commandVis = true;
                }else if(val == 4){
                    checkDevicerigth().then(res => {
                        if(res && res.data && res.data.success){
                            this.commandVis = true;
                        }else{
                            this.$message.warning("堆簇电池包结构不正确！");
                        }
                    })
                }else if(val == 3){
                    this.commandVis = true;
                }
            },

            getDeviceList(deviceType){
              return this.deviceList.filter(i => i.deviceType == deviceType);
            },

            deviceTypeChange(){
                //this.addForm.upDeviceId = '';
                console.log(this.upDeviceList);
            },

            subminBacth(){
                let FN;
                let params;
                if(this.commandAction == 0){
                    params = {
                        deviceIds:  this.multipleSelection.map(i => i.id).join(","),
                        value: this.commandForm.deviceType,
                    };
                    FN = updataUpDevice;
                }else if(this.commandAction == 1){
                    params = {
                        deviceIds:  this.multipleSelection.map(i => i.id).join(","),
                        value: this.commandForm.systemId,
                    };
                    FN = updateDeviceSys;
                }else if(this.commandAction == 2){
                    params = {
                        deviceIds:  this.multipleSelection.map(i => i.id).join(","),
                        value: this.commandForm.exdInfo,
                    };
                    if(params.value == undefined || params.value == ""){
                        params.value = {}
                    }else{
                        if(isJSON(params.value) == false){
                            this.$message.error("扩展字段必须为合法的JSON！");
                            return false
                        }else{
                            params.value = JSON.parse(params.value);
                        }
                    }
                    FN = updateDeviceExdInfo;
                }else if(this.commandAction == 3){

                }else if(this.commandAction == 4){
                    const {
                        duiPlanCapacity,
                        duiDcPackNum,
                        duiDcNum,
                        duiTempNum
                    } = this.commandForm;
                    params =  {
                        duiPlanCapacity,
                        duiDcPackNum,
                        duiDcNum,
                        duiTempNum
                    };
                    if(duiPlanCapacity == "" || duiPlanCapacity == null || duiPlanCapacity == undefined){
                        this.$message.error("堆容量必须填写！");
                        return false
                    }
                    FN = updateDeviceDui;
                }

                this.$confirm(i18n.t("ems.alarm.sureyouwanttodothis"), {
                    confirmButtonText: i18n.t("ems.strategy.confirm"),
                    cancelButtonText:  i18n.t("ems.strategy.cancel"),
                    type: "warning"
                }).then(() => {
                    FN(params).then(() =>  {
                        this.$message.success("操作成功！");
                        this.loadData();
                        this.commandVis = false;
                    }).catch(err => {
                        this.$message.error(err)
                    });
                }).then(() => {
                });
            },

            closePanel(isLoading){
                this.commandVis = false;
                if(isLoading){
                    this.loadData();
                }
            },

            submitUpload() {
                if (this.fileList.length === 0) {
                    this.$message.error("请选择文件！");
                    return;
                }
                this.$refs.upload.submit();
            },
            uploadSuccess(res) {
                if (res.success) {
                    this.$message({
                        type: "success",
                        message: "操作成功！",
                    });
                    this.uploadVis = false;
                    this.search();
                } else {
                    this.$refs.upload.clearFiles();
                    this.$message.error("上传文件失败！" +  res.msg);
                }
            },
            handleError(res) {
                console.log(JSON.stringify(res));
                this.$message.error("上传文件失败！" +  res.msg);
            },
            handleTemplate(){
                window.open("/export-device.xlsx", "_blank");
            },
            beforeAvatarUpload(file) {
                console.log(file);
                const isJPG = file.type.includes("sheet");
                const isLt2M = file.size / 1024 / 1024 < 10;

                if (!isJPG) {
                    this.$message.error("上传文件只能是 xls，wps 格式!");
                }
                if (!isLt2M) {
                    this.$message.error("上传文件大小不能超过 10MB!");
                }
                return isJPG && isLt2M;
            },
            handleExceed(files, fileList) {
                this.$message.warning(
                    `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
                    files.length + fileList.length
                        } 个文件`
                );
            },
            handleChange(file, fileList) {
                this.fileList = fileList.slice(-3);
            },
            handleUpload(){
                this.uploadVis= true;
                this.containerId = '';
            },
            onShowDataCheck(row){
                const { deviceNo } = row;
                this.dataCheckForm.deviceNo = deviceNo;
                this.dataCheckVisible = true;
                this.dataCheckLoading = true;
                deviceDataCheck({ deviceNo }).then((res)=>{
                    this.dataCheckLoading = false;
                    this.dataCheckList = res.data.data || [];
                }).catch((err)=>{
                    this.dataCheckLoading = false;
                })
            },
            onDataCheckChange(){
               this.dataCheckLoading = true;
               deviceDataCheck(this.dataCheckForm).then((res)=>{
                    this.dataCheckLoading = false;
                    this.dataCheckList = res.data.data || [];
                }).catch((err)=>{
                    this.dataCheckLoading = false;
                })
            },
            deleteAll(){
                if(this.multipleSelection.length === 0){
                    this.$message.warning("请选择数据！");
                    return false;
                }
                const deviceIds = this.multipleSelection.map(i => i.id).join(',');
                this.$confirm(i18n.t("ems.alarm.sureyouwanttodothis"), {
                    confirmButtonText: i18n.t("ems.strategy.confirm"),
                    cancelButtonText:  i18n.t("ems.strategy.cancel"),
                    type: "warning"
                }).then(() => {
                    deleteDevicePacth(deviceIds).then(() =>  {
                        this.$message.success(i18n.t("ems.strategy.DeletedSuccessfully"));
                        this.loadData();
                    }).catch(err => {
                        this.$message.error(err)
                    });
                }).then(() => {
                });
            },
            downLoad(){
                const params = {
                    "gatewayNos": this.form.gatewayNos.join(','),
                    "deviceTypes": this.form.deviceTypes.join(',')
                };
                exportDevices(params).then(res => {
                    this.$message.success("downloading");
                    let fileName = res.headers['content-disposition'];
                    fileName = fileName.slice(fileName.indexOf('=') + 1, fileName.indexOf('.'));
                    exportFile(res.data, fileName, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
                    // exportFile(res.data, fileName);
                });
            },
        }
    }
</script>

<style scoped lang="scss">
    @import "../../styles/site";
    .win{
        width: 100%;
        height: 100%;
        .header{
            height: 52px;
            background-color: var(--nav_inner);
            position: relative;
            .navItem{
                height: 100%;
                color: $font_bright_blue_title;
                display: flex;
                align-items: center;
                transition: all 0.3s linear;
                i{
                    font-size: 22px;
                    margin: 3px 20px 0;
                }
                .title{
                    letter-spacing: 3px;
                    font-size: 22px;
                }
                .desc{
                    margin-left: 24px;
                    font-size: 16px;
                    color: $_128_128_128;
                }
            }
            .navRight{
                position: absolute;
                height: 100%;
                right: 0;
                top: 0;
                display: flex;
                align-items: center;
                .creatTime{
                    font-size: 18px;
                    color: $_191_191_191;
                    margin-right: 40px;
                    span{
                        padding-left: 20px;
                        color: $font_bright_blue_title
                    }
                }
                .btn{
                    height: 30px;
                    width: 85px;
                    border: $font_bright_blue_title solid 2px;
                    margin-right: 20px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 16px;
                    color: $font_bright_blue_title;
                    cursor: pointer;
                    -webkit-tap-highlight-color:rgba(0,0,0,0);
                    i{
                        margin-right: 5px;
                        font-size: 18px;
                    }
                }
            }
        }
        .content{
            padding: 0 20px;
            overflow: hidden;

            .table_header {
                margin-top: 20px;
                height: 30px;
                margin-bottom: 20px;
            }
            .page{
                margin-top: 20px;
                height: 30px;
            }
            .strategy_main {
                height: 780px;
            }
        }
    }


</style>
<style lang="scss">
    .gatewayBind{
        margin: 10px 20px;
        color: #0acfe6;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 400px;
    }
</style>